import { http } from './http';

function normalizeVehicleRecordPayload(p) {
    if (!p || typeof p !== 'object') return p;
    const out = { ...p };
    const b = out.book;
    if (Array.isArray(b)) {
        if (b.length > 0) {
            const first = b[0];
            out.book = typeof first === 'object' && first !== null ? first.id : first;
        } else {
            delete out.book;
        }
    } else if (typeof b === 'object' && b !== null) {
        if ('id' in b) out.book = b.id;
    }
    const v = out.vehicle;
    if (Array.isArray(v)) {
        if (v.length > 0) {
            const firstV = v[0];
            out.vehicle = typeof firstV === 'object' && firstV !== null ? firstV.id : firstV;
        } else {
            delete out.vehicle;
        }
    } else if (typeof v === 'object' && v !== null) {
        if ('id' in v) out.vehicle = v.id;
    }
    return out;
}

export async function listVehicleRecords(params = {}) {
    const { data } = await http.get('book/vehicle-records/', { params });
    return data;
}

export async function getVehicleRecord(id) {
    const { data } = await http.get(`book/vehicle-records/${id}/`);
    return data;
}

export async function createVehicleRecord(payload) {
    const normalized = normalizeVehicleRecordPayload(payload);
    const { data } = await http.post('book/vehicle-records/', normalized);
    return data;
}

export async function updateVehicleRecord(id, payload) {
    const normalized = normalizeVehicleRecordPayload(payload);
    const { data } = await http.patch(`book/vehicle-records/${id}/`, normalized);
    return data;
}


export async function deleteVehicleRecord(id) {
    const { data } = await http.delete(`book/vehicle-records/${id}/`);
    return data;
}